import React, { useState } from "react";
import about from "./assets/img/3.png";
import SecondaryPopup from "./SecondaryPopup";
// import Secondary from "./Primary";

const Secondarys = () => {
  const [showPrimaryPopup, setShowPrimaryPopup] = useState(false);
  const handelOnClosePrimary = () => setShowPrimaryPopup(false);
  function handelOnClick() {
    console.log('true')
    setShowPrimaryPopup(true);
  }
  return (
    <div className="container">
      <div style={{ display: "flex" }} className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <p className="text-xl text-gray leading-7 mx-[20px] sm:mx-40">
            <h1 className="font-bold text-3xl text-[#8C1F1F] mt-[9vw]">Secondary</h1> <br />
            <p>
              Our method of teaching encourages a lot of creativity especially
              because it is student centered...
            </p>
            <button
              onClick={() => setShowPrimaryPopup(true)}
              className="text-[#722828] bg-transparen font-bold"
            >
              Read More
            </button>
          </p>
        </div>
        <div className=" col-lg-6 col-md-6 col-sm-12 ">
          <img src={about} alt="" className="h-20px mt-5 " />
        </div>
        <br />
      </div>
      <SecondaryPopup onClose={handelOnClosePrimary} visible={showPrimaryPopup} />
    </div>
  );
};

export default Secondarys;

{/* <div className="flex flex-col-reverse md:grid-cols-2 gap-10 place-items-center"> */ }